module.exports = __webpack_public_path__ + "static/ethereum-c48a5f760c34dfadcf05a208dab137cc.png";